export const CheckForSignUpEnabled = () => {
  const App_Prefrences = localStorage.getItem(
    'nobat_prefrence'
  )
    ? JSON.parse(localStorage.getItem('nobat_prefrence'))
    : '';

  const canRegister = App_Prefrences
    ? App_Prefrences?.filter(
        (prefrence) => prefrence.Key === 'webAppcanRegister'
      )[0]?.Value === 'True'
    : null;

  return canRegister;
};
